require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-raiding.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-raiding");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-raiding!./.cache/json/betreuungseinrichtungen-oberpullendorf-raiding.json
// module id = 991
// module chunks = 231608221292675